import React from 'react'
import { Trans, useTranslation } from 'i18n'
import IntersectionVisible from 'components/IntersectionVisible'
import { legacyImageURL } from 'components/LegacyImage'
import analytics from 'global/AnalyticsData'
import StepBackground from '../StepBackground4.jsx'
import './Landing.scss'
import BreakHTMLFooter from 'steps/BreakHTMLFooter'

import CircleArrowSVG from 'images/inline/arrow-button.svg'
import { StepSpacingWrapper } from 'components/StepSpacingWrapper/StepSpacingWrapper'
import { titleParser } from 'util/titleParser'
import PlaceholderImage from 'components/PlaceholderImage.jsx'

/*

Landing page
Pure UI/render here. all logic handled by LandingStep.jsx
welcome message and a start button

*/

const LandingStep = ({
  brk,
  onAttemptStart,
  onStartClick,
  isEmbed,
  hasLogo,
  isHub,
  onIntersect = (stepId, isIntersecting) => {},
}) => {
  const { t } = useTranslation(['landing', 'common'])
  const arrowButtonHandler = async e => {
    console.log(`event: landing_start_button_click fired`)
    // before we actually start, run this up the flag pole to make sure we're ok to start (user is logged in)
    const okToStart = await onAttemptStart('landing')
    console.log(`okToStart: `, okToStart)

    if (okToStart === true) {
      analytics.breakEvent('landing_start_button_click', brk)
      onStartClick()
    }
  }

  const handleIsOnScreen = async isIntersecting => {
    onIntersect('landing', isIntersecting)
  }

  // temporary cleanup:
  // new data coming in has a field brk.hasBackgroundOverlay set to true by default
  // cached data doesn't have this field, so it will be undefined (or falsy)
  // so if it's undefined, make it default (true)
  if (brk.hasBackgroundOverlay === undefined) {
    brk.hasBackgroundOverlay = true
  }

  let landingFooter = ''
  if (brk && brk.footerHtml) {
    landingFooter = landingFooter + brk.footerHtml
  }
  if (brk && brk.landingPageFooterHtml) {
    landingFooter = landingFooter + brk.landingPageFooterHtml
  }

  const WE_DONT_HAVE_A_BEAKER_FIELD_FOR_THIS = null

  return (
    <IntersectionVisible onIntersect={handleIsOnScreen}>
      <div
        className={`landing-step-new step-landing-new sponsored-flow-panel logo-${hasLogo} overlay-${
          brk.hasBackgroundOverlay ? '1' : '0'
        }`}
      >
        <StepSpacingWrapper>
          <div className="landing-new-component">
            {/* older breaks displayed the desktop image on mobile. we need to account for that untl content has an opportunity to fix. */}
            <StepBackground
              backgroundColor={WE_DONT_HAVE_A_BEAKER_FIELD_FOR_THIS}
              mobileBackgroundId={
                brk.mobileBackgroundImageId || brk.backgroundImageId
              }
              backgroundImageId={brk.backgroundImageId}
              backgroundImageAlt={(brk.backgroundImage && brk.backgroundImage.altAttribute) || ''}
              mobileBackgroundImageAlt={(brk.mobileBackgroundImage && brk.mobileBackgroundImage.altAttribute) || ''}
            />
            <div className="content-wrapper">
              <div className="content">
                {/* We are injecting some content here with custom css (we need to fix this) */}
                <p className="activity" />
                
                
                { brk.overrideMobileMapPageCopy ?
                  <>
                    {/* if overrideMobileMapPageCopy == true then output fields with css classes to show/hide */}
                    { (brk.mapHeadlineType === 'IMAGE') && brk.mapHeadlineImage && 
                      <PlaceholderImage 
                        className="for-desktop-only"
                        src={legacyImageURL(brk.mapHeadlineImage)}
                        alt={brk.mapHeadlineImage.altAttribute || ''}
                      />
                    }
                    { (brk.mobileMapHeadlineType === 'IMAGE') && brk.mobileMapHeadlineImage && 
                        <PlaceholderImage 
                          className="for-mobile-only"
                          src={legacyImageURL(brk.mobileMapHeadlineImage)}
                          alt={brk.mobileMapHeadlineImage.altAttribute || ''}
                        />
                    }
                    { (brk.mapHeadlineType === 'TEXT') && brk.mapHeadline && 
                      <h1
                        className={`landing-step-headline for-desktop-only`}
                        dangerouslySetInnerHTML={{
                          __html: titleParser(brk.mapHeadline),
                        }}
                      />
                  }
                  { (brk.mobileMapHeadlineType === 'TEXT') && brk.mapHeadlineMobile && 
                      <h1
                        className="landing-step-headline for-mobile-only"
                        dangerouslySetInnerHTML={{
                          __html: titleParser(brk.mapHeadlineMobile),
                        }}
                      />
                  }
                  { brk.mapDescription && (
                    <div
                      className="landing-description for-desktop-only"
                      dangerouslySetInnerHTML={{ __html: brk.mapDescription }}
                    />
                  )}
                  { brk.mapDescriptionMobile && (
                    <div
                      className="landing-description landing-description-mobile for-mobile-only"
                      dangerouslySetInnerHTML={{
                        __html: brk.mapDescriptionMobile,
                      }}
                    />
                  )}
                  </>
                :
                  <>
                  {/* if overrideMobileMapPageCopy == false then output desktop fields without css classes to show/hide */}
                  {/*
                    newer logic - removes mobile/desktop classnames
                    { (brk.mapHeadlineType === 'IMAGE') && brk.mapHeadlineImage && 
                        <PlaceholderImage 
                          className=""
                          src={legacyImageURL(brk.mapHeadlineImage)}
                          alt={brk.mapHeadlineImage.altAttribute || ''}
                        />
                    }
                    { (brk.mapHeadlineType === 'TEXT') && brk.mapHeadline && 
                        <h1
                          className={`landing-step-headline`}
                          dangerouslySetInnerHTML={{
                            __html: titleParser(brk.mapHeadline),
                          }}
                        />
                    }
                    { brk.mapDescription && (
                      <div
                        className="landing-description"
                        dangerouslySetInnerHTML={{ __html: brk.mapDescription }}
                      />
                    )}
                  */}
                  {/* Previous logic */}
                    {brk.mapHeadlineType === 'IMAGE' && (
                      <>
                        <img
                          className="for-desktop-only"
                          src={legacyImageURL(brk.mapHeadlineImage)}
                          alt={brk.mapHeadlineImage?.altAttribute || brk.mapHeadline || ''}
                        />
                        <h1
                          className="landing-step-headline for-mobile-only"
                          dangerouslySetInnerHTML={{
                            __html: titleParser(brk.mapHeadline),
                          }}
                        />
                      </>
                    )}
                    {brk.mapHeadlineType === 'TEXT' && (
                      <h1
                        className={`landing-step-headline`}
                        dangerouslySetInnerHTML={{
                          __html: titleParser(brk.mapHeadline),
                        }}
                      />
                    )}

                    {brk.mapDescription && (
                      <div
                        className="landing-description"
                        dangerouslySetInnerHTML={{ __html: brk.mapDescription }}
                      />
                    )}
                    {!brk.mapDescription && brk.mapDescriptionMobile && (
                      <div
                        className="landing-description landing-description-mobile"
                        dangerouslySetInnerHTML={{
                          __html: brk.mapDescriptionMobile,
                        }}
                      />
                    )}
                  </>
                }



                {(isEmbed || isHub) && (
                  <p className="terms">
                    <Trans
                      t={t}
                      i18nKey="landing:termsAcknowledgement"
                      components={{
                        termsLink: <a href="/terms/" target="_blank" />,
                        privacyLink: <a href="/privacy/" target="_blank" />,
                      }}
                    />
                  </p>
                )}

                <p>
                  {/* <span className="btn start-button" onClick={arrowButtonHandler}>Start</span> */}
                  <button
                    className="arrow-button2"
                    onClick={arrowButtonHandler}
                    aria-label={t('common:next')}
                  >
                    <CircleArrowSVG alt={t('landing:nextStepIconAlt')} />
                  </button>
                </p>
              </div>
              <BreakHTMLFooter content={landingFooter} />
            </div>
          </div>
        </StepSpacingWrapper>
      </div>
    </IntersectionVisible>
  )
}
export default LandingStep
